<div class="flex flex-col py-8 justify-center" style="overflow: hidden;">
  <div class="container-padding max-w-screen-desktop mx-auto w-full">
    <div class="grid grid-cols-1 mobile-m:grid-cols-2 gap-8">
      <div class="col-span-1">
        <div class="relative mb-16">
          <div class="w-full flex flex-col justify-center items-center">
            <div class="relative z-[2] w-full flex justify-center items-center">
              <img src="assets/mascota.webp" alt="drinkhopping - hoppinsito" class="h-[260px]" />
            </div>
            <h1 class="relative z-[1] text-[var(--black)] text-[60px]/[60px]" style="width: min-content;">
              <span class="block">{{ 'register.explora' | translate }}</span>
              <span class="block">{{ 'register.disfruta' | translate }}</span>
              <span class="block">{{ 'register.ahorra' | translate }}</span>
              <span class="block">{{ 'register.registrate' | translate }}</span>
            </h1>
          </div>
          <div class="absolute z-[0] top-[0%] left-[-0%] w-full">
            <img src="assets/explosion-fondo.webp" style="opacity: 0.2;" alt="drinkhopping - hoppinsito" class="w-full max-h-[645px] object-contain" />
          </div>
        </div>
      </div>

      <div class="col-span-1">
        <div class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)]">
          <h2 class="uppercase text-[42px]/[65px] font-normal text-[var(--dark-orange)]">
            {{ 'register.title' | translate }}
          </h2>
          <div class="w-full border-t border-dotted mb-6 mt-2"></div>

          <form [formGroup]="registerForm" (submit)="onSubmit()" class="">
            <div class="flex flex-col gap-6">
              <app-input [control]="registerForm.controls['name']" inputId="name" type="text" placeholder="Jhon Doe"
                [label]="'register.fullName' | translate" filterType="name" [maxlength]="40"></app-input>

              <app-input [control]="registerForm.controls['email']" inputId="email" autocomplete="email" type="email" placeholder="usuario@correo.com"
                [label]="'register.email' | translate"></app-input>

              <app-input-phone [control]="phoneForm.controls['phone']" inputId="phone" type="phone" placeholder="xxxxxxxx"
                autocomplete="phone" [label]="'register.phone' | translate"></app-input-phone>

              <app-input [control]="registerForm.controls['password']" inputId="password" type="password" placeholder="******"
                autocomplete="new-password" [label]="'register.password' | translate"></app-input>

              <app-input [control]="registerForm.controls['confirmPassword']" inputId="confirmPassword" type="password" placeholder="******"
                autocomplete="confirm-password" [label]="'register.confirmPassword' | translate"></app-input>

              <app-input-checkbox [control]="registerForm.controls['acceptTerms']" inputId="acceptTerms" type="checkbox"
                [label]="'register.ageConfirm' | translate"></app-input-checkbox>
            </div>

            <div class="mt-8">
              <app-button [submit]="true" [disabled]="isLoading" [text]="isLoading ? ('register.loading' | translate) : ('register.submit' | translate)" [fullWidth]="true"></app-button>
            </div>

            <div *ngIf="errorMessage" class="mt-6 font-bold text-[14px]/[14px] text-center" style="color: red;">
              {{ errorMessage }}
            </div>

            <div class="mt-12 flex justify-center p-3">
              <a routerLink="/login" [queryParamsHandling]="'preserve'" class="uppercase font-bold text-[var(--black)] text-[14px]/[14px]">
                {{ 'register.alreadyHaveAccount' | translate }}
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
